module.exports = __webpack_public_path__ + "img/sangao_banner.d0ebefe7.png";